import { getLookupQuery } from 'src/app/helpers/url.helper';
import { apiSlice } from 'src/app/redux/api/apiSlice';
import {
  VehicleRecognizedLookupDataType,
  VehicleRecognizedLookupResultType,
} from 'src/app/redux/interests/vehicles/vehicle-slice.type';
import { finalUrlsConfig } from 'src/configs/url.config';

export const vehicleRecognizedSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVehiclesRecognized: builder.query<VehicleRecognizedLookupResultType, VehicleRecognizedLookupDataType | void>({
      query: (params: VehicleRecognizedLookupDataType) => ({
        url: finalUrlsConfig().interest.recognized.vehicle,
        params: getLookupQuery(params),
      }),
    }),
  }),
});

export const { useGetVehiclesRecognizedQuery } = vehicleRecognizedSlice;
